
const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;

const load = (page) => {
  return() => import(`@/pages/${page}/${page}.vue`);
}

const amdinRoutes = {
  path: '/admin',
  component: () => import(`@/layouts/AdminLayout/AdminLayout.vue`),
  meta: {
    isCompanySwitchingZone: true,
    zone: 'public',
  },
  children: [
    {
      name: 'api',
      path: 'api',
      component: load('Api'),
      alias: '/api',
      beforeEnter: function(to, from, next) {
        nodeEnv !== "development" ? next("/") : next();
      },
    }
  ]
};

export default amdinRoutes;